import getDetail from './getDetail';

export default ({ information: { sportLabel }, keyDetails }) => {
  if (!keyDetails) {
    return sportLabel;
  }
  const sportDetails = keyDetails.filter(d => d.type === 1001 || d.type === 1006); // See getDetail
  const details = sportDetails.map(d => `${getDetail(d.type, d.id)} ${d.value}`).join(', ');
  if (sportDetails.length === 1) {
    return details;
  }
  return `${sportLabel}: ${details}`;
};



// WEBPACK FOOTER //
// ./app/src/components/RaceSummary/helpers/getDistanceLabel.js